export default __webpack_public_path__ + "static/media/thumbs-down-disabled.c4a216ce.svg";